/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../../shared/shared.module';
import { CommonComponentsModule } from '../../components/common-components.module';
import { UtEditorModule } from '../../ut-editor/ut-editor.module';
import { EmojiHtmlPipe } from '../../../pipes/emoji-html.pipe';
import { CommunityModule } from '../community.module';
import { UtCategoryLinkModule } from './category-link/category-link.module';
import { CommunityHideActionComponent } from './actions/community-hide-action.component';
import { CommunityLikeActionComponent } from './actions/community-like-action.component';
import { CommunityReportActionComponent } from './actions/community-report-action.component';
import { CommunitySubscribeActionComponent } from './actions/community-subscribe-action.component';
import { ConfirmActionDialogComponent } from './actions/confirm-action-dialog.component';
import { ReportDialogComponent } from './actions/report-dialog.component';
import { CommunityFeedItemCommentsComponent } from './comments/community-feed-item-comments.component';
import { CommunityFeedItemComponent } from './feed-item/community-feed-item.component';
import { CommunityLikeListDialogComponent } from './like-list/community-like-list-dialog.component';
import { CommunityLikersComponent } from './likers/community-likers.component';
import { StatusAttachmentComponent } from './status-attachment/status-attachment.component';
import { CommunityStatusFormComponent } from './status-form/community-status-form.component';
import { StatusAttachmentPickerComponent } from './status-form/status-attachment-picker.component';

// The community feed card and the parts around it (actions, comments, likers, like list, status form),
// shared by the community page, the community profile and other 2026-design pages.
// Not standalone: these components use NgModules that pull in UpgradeModule (via UIRouterUpgradeModule),
// and a standalone component importing those gets its own injector, which re-runs UpgradeModule's
// one-shot `$injector` factory and throws "Trying to get the AngularJS injector before it being set".
@NgModule({
  imports: [
    CdkMenuModule,
    CommonModule,
    FormsModule,
    MatDialogModule,
    UIRouterModule,
    SharedModule,
    CommonComponentsModule,
    CommunityModule,
    UtEditorModule,
    UtCategoryLinkModule,
    EmojiHtmlPipe,
  ],
  declarations: [
    CommunityFeedItemComponent,
    CommunityFeedItemCommentsComponent,
    CommunityLikersComponent,
    CommunityLikeListDialogComponent,
    StatusAttachmentComponent,
    StatusAttachmentPickerComponent,
    CommunityStatusFormComponent,
    ConfirmActionDialogComponent,
    ReportDialogComponent,
    CommunityLikeActionComponent,
    CommunitySubscribeActionComponent,
    CommunityHideActionComponent,
    CommunityReportActionComponent,
  ],
  // The actions, likers and confirmation dialog are also used on their own by the forums, tool and
  // article pages (ut-item-actions, the comment thread, the pending articles queue).
  exports: [
    CommunityFeedItemComponent,
    CommunityStatusFormComponent,
    StatusAttachmentComponent,
    CommunityLikeActionComponent,
    CommunitySubscribeActionComponent,
    CommunityHideActionComponent,
    CommunityReportActionComponent,
    CommunityLikersComponent,
    ConfirmActionDialogComponent,
  ],
})
class CommunityFeedModule {}

export { CommunityFeedModule };
